import React, { createContext, useState } from "react";
import FullPageLoader from "../components/utils/FullPageLoader";
import BootstrapLoader from "../components/utils/BootstrapLoader";

export const LoaderContext = createContext(null);

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);

  return (
    <LoaderContext.Provider
      value={{ loading, setLoading, pageLoading, setPageLoading }}
    >
      {children}
      {loading && <FullPageLoader />}
      {pageLoading && <BootstrapLoader />}
    </LoaderContext.Provider>
  );
};
